import React, { Component } from "react"
import Select from "react-select"
import "./index.scss"
import Text from "components/text"

export default class FormDropdown extends Component {
  handleChange = (data) => {
    const { handleChange = false, name, fieldRef } = this.props
    const textName = fieldRef?.current?.props?.name
    if (handleChange && data) {
      data.name = name
      handleChange(data)
    } else {
      handleChange({ value: "", label: "", name: textName })
    }
  }

  render() {
    const {
      options,
      label,
      labelFor,
      value,
      name,
      error,
      required,
      optionGroups,
      disabled,
      loading,
      fieldRef,
      isClearable,
    } = this.props
    let defaultValue = {}

    if (value) {
      if (options) {
        defaultValue = options.find((option) =>
          Object.values(option).includes(value)
        )
      } else if (optionGroups) {
        optionGroups.some((group) => {
          const { options = [] } = group
          defaultValue = options.find((option) =>
            Object.values(option).includes(value)
          )

          return defaultValue
        })
      }
    }

    let hasError = Boolean(error)
    return (
      <div className="form-input">
        {label && <Text type="label" text={label + (required ? " *" : "")} />}
        <Select
          name={name}
          value={defaultValue || {}}
          onChange={this.handleChange}
          options={optionGroups || options || []}
          className="select"
          classNamePrefix="select"
          isDisabled={disabled}
          isLoading={loading}
          ref={fieldRef}
          isClearable={isClearable}
        />
        {labelFor && <p className="form-hint">{labelFor}</p>}
        {hasError && <p className="error-message">{`* ${error}`}</p>}
      </div>
    )
  }
}
